import { getSuccessActionType } from "../utils/get-action-types";
import {
  FETCH_BOOKINGS_REPORT,
  FETCH_PAGE_VISITS_REPORT,
  FETCH_TEL_LOOKUPS_REPORT,
  FETCH_BOOKINGS_REPORT_BASED_DOCTOR,
} from "../constants/reports";
import { getFailureActionType, getRequestActionType } from "../utils";
import { ERROR, LOADING, OK } from "../constants";
import { Action, ReportsState } from "../models/reports";

function data(state: ReportsState = {}, action: Action): ReportsState {
  const officeId = action.data && action.data.officeId ? action.data.officeId : 0;
  const doctorId = action.data && action.data.doctorId ? action.data.doctorId : 0;

  switch (action.type) {
    case getRequestActionType(FETCH_PAGE_VISITS_REPORT):
      return {
        ...state,
        [officeId]: {
          ...state[officeId],
          pageVisits: {
            status: LOADING,
            error: {},
          },
        },
      };
    case getSuccessActionType(FETCH_PAGE_VISITS_REPORT):
      return {
        ...state,
        [officeId]: {
          ...state[officeId],
          pageVisits: {
            status: OK,
            error: {},
            data: action.payload,
          },
        },
      };
    case getFailureActionType(FETCH_PAGE_VISITS_REPORT):
      return {
        ...state,
        [officeId]: {
          ...state[officeId],
          pageVisits: {
            status: ERROR,
            error: action.payload,
          },
        },
      };
    case getRequestActionType(FETCH_TEL_LOOKUPS_REPORT):
      return {
        ...state,
        [officeId]: {
          ...state[officeId],
          telLookups: {
            status: LOADING,
            error: {},
          },
        },
      };
    case getSuccessActionType(FETCH_TEL_LOOKUPS_REPORT):
      return {
        ...state,
        [officeId]: {
          ...state[officeId],
          telLookups: {
            status: OK,
            error: {},
            data: action.payload,
          },
        },
      };
    case getFailureActionType(FETCH_TEL_LOOKUPS_REPORT):
      return {
        ...state,
        [officeId]: {
          ...state[officeId],
          telLookups: {
            status: ERROR,
            error: action.payload,
          },
        },
      };
    case getRequestActionType(FETCH_BOOKINGS_REPORT):
      return {
        ...state,
        [officeId]: {
          ...state[officeId],
          bookings: {
            status: LOADING,
            error: {},
          },
        },
      };
    case getSuccessActionType(FETCH_BOOKINGS_REPORT):
      return {
        ...state,
        [officeId]: {
          ...state[officeId],
          bookings: {
            status: OK,
            error: {},
            data: action.payload,
          },
        },
      };
    case getFailureActionType(FETCH_BOOKINGS_REPORT):
      return {
        ...state,
        [officeId]: {
          ...state[officeId],
          bookings: {
            status: ERROR,
            error: action.payload,
          },
        },
      };
    case getRequestActionType(FETCH_BOOKINGS_REPORT_BASED_DOCTOR):
      return {
        ...state,
        [doctorId]: {
          ...state[doctorId],
          bookings: {
            status: LOADING,
            error: {},
          },
        },
      };
    case getSuccessActionType(FETCH_BOOKINGS_REPORT_BASED_DOCTOR):
      return {
        ...state,
        [doctorId]: {
          ...state[doctorId],
          bookings: {
            status: OK,
            error: {},
            data: action.payload,
          },
        },
      };
    case getFailureActionType(FETCH_BOOKINGS_REPORT_BASED_DOCTOR):
      return {
        ...state,
        [doctorId]: {
          ...state[doctorId],
          bookings: {
            status: ERROR,
            error: action.payload,
          },
        },
      };
    default:
      return state;
  }
}

export default data;
